module.exports = __webpack_public_path__ + "dd611451a70a035a501d101aaae471.png";